<template>
    <b-navbar toggleable="lg" type="light" variant="light" class="navbar-user">
        <b-navbar-brand :to="{name: 'UserPanel'}"><img src="~img/logo.png" alt=""></b-navbar-brand>

        <b-navbar-toggle target="nav_collapse" />

        <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav class="nav nav-tabs">
                <b-nav-item :to="{name: 'UserPanel'}" active-class="active" exact>Home</b-nav-item>
                <b-nav-item-dropdown text="Inventory" :extra-toggle-classes="/inventory/i.test(this.$route.path) ? 'active' : ''" no-caret>
                    <b-dropdown-item :to="{name: 'InventoryManagement'}">Inventory management</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'AddProducts'}">Add a product</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown text="Orders" :extra-toggle-classes="/orders/i.test(this.$route.path) ? 'active' : ''" no-caret>
                    <b-dropdown-item :to="{name: 'Sales'}">Sales</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'Orders'}">Orders</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'NewOrder'}">New Order</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right no-caret>
                    <!-- Using button-content slot -->
                    <template slot="button-content"><strong>Settings</strong></template>
                    <b-dropdown-item :to="{name: 'Profile'}">Profile</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'ShippingSettings'}">Shipping Settings</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'Marketplaces'}">Link E-shops</b-dropdown-item>
                    <b-dropdown-item @click="$store.commit('LOGOUT')">Sign-out</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
    export default {
        name: 'UserPanelHeader',
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/UserPanelHeader.vue